export default {
    primary: '#1c2856',
    secondary: '#707173',
    accent: '#8c9eff',
    success: '#83b33f',
    error: '#b71c1c',
    edit: '#ff851a',
    background: '#FFFFFF',
    mainTheme: '#445861',
    sectionMenu: '#b0d141',
    navbar: '#1c2856',
    sidebar: '#1c2856',

    yellowProp: '#F2C300'
}
